import { Controller } from "@hotwired/stimulus"

// One-tap answers: marks the tapped answer chosen, holds it for a beat so the choice registers, then submits it.
// Each answer is a submit button, so without JavaScript it submits at once. The chosen value is what the
// buttons' aria-pressed (and the styles on it) follow; once set, further taps wait for the submission.
export default class extends Controller {
  static targets = ["choice"]
  static values = { delay: Number, chosen: String }

  disconnect() {
    clearTimeout(this.timeout)
  }

  choose(event) {
    event.preventDefault()
    if (this.chosenValue) return

    const choice = event.currentTarget
    this.chosenValue = choice.value
    this.timeout = setTimeout(() => choice.form.requestSubmit(choice), this.delayValue)
  }

  // Before Turbo caches the page, so a Back to it takes taps again.
  reset() {
    clearTimeout(this.timeout)
    this.chosenValue = ""
  }

  // A submission of an answer that fails leaves the merchant on this page, so the answers take taps again.
  unlock({ target, detail: { success } }) {
    if (!success && this.choiceTargets.some((choice) => choice.form === target)) this.reset()
  }

  chosenValueChanged(chosen) {
    if (!chosen) return

    this.choiceTargets.forEach((choice) => choice.setAttribute("aria-pressed", choice.value === chosen))
  }
}
